import React from 'react';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const DeleteActionMenu = ({ onClick, disabled }) => (
  <RibbonMenu
    name="refresh"
    icon="trash alternate"
    message="actions.delete"
    onClick={onClick}
    disabled={disabled}
    className="aridhia-delete-action-menu"
  />
);

export default DeleteActionMenu;
